import { render, staticRenderFns } from "./UserViewer.vue?vue&type=template&id=ef566350&scoped=true&lang=pug"
import script from "./UserViewer.vue?vue&type=script&lang=js"
export * from "./UserViewer.vue?vue&type=script&lang=js"
import style0 from "./UserViewer.vue?vue&type=style&index=0&id=ef566350&prod&lang=scss&scoped=true"
import style1 from "./UserViewer.vue?vue&type=style&index=1&id=ef566350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.105.4__lodash@4_d129e92f74051bdaf507e89873890984/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef566350",
  null
  
)

export default component.exports